import omit from 'lodash/omit'

export default {
  props: {
    name: {
      type: String,
      required: true
    }
  },
  watch: {
    '$route.query': {
      handler(query) {
	if (this.values.includes(query[this.name])) {
	  this.value = query[this.name]
	}
	else {
	  this.value = this.defaultValue
	}
      },
      immediate: true
    },
    value(value) {
      if (!this.validate(value)) {
	this.$router.push({
	  query: omit(this.$route.query, this.name)
	})
      }
      else {
  // drop if default
  
	if (value === this.defaultValue) {
	  this.$router.push({
	    query: omit(this.$route.query, this.name)
	  })
	}
	else {
    console.log(this.$route.query)
	  this.$router.push({
	    query: {
	      ...this.$route.query,
	      [this.name]: this.value
	    }
	  })
	}
      }
    }
  },
  data() {
    return {
      value: this.defaultValue
    }
  },
  computed: {
    values() {
      return this.options.map((option) => option.value)
    }
  },
  methods: {
    validate(value) {
      // NOTE: strict comparison
      return this.values.includes(value)      
    }
  }
}
